import React, { useEffect, useState, useContext ,useRef} from "react";
import { Container, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import ReadMore from "./../../CommonUI/ReadMoreBtn/ReadMore";
import Slider from "react-slick";
import EquityImg from "../../../Images/product-equity.png";
import CompanyLogo from "./../../../Images/comlogo.png";
import { Vortex } from 'react-loader-spinner'
import "./ProductTopEquity.css";
import URLstateContext from "../../../provider/CommonContext";
import { setcompcode, userSelector,clearState } from '../../features/User/UserSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useLocalStorage } from "../../utils/useLocalStorage";
import LoginPopup from "../../CommonUI/LoginPopup/LoginPopup";
function ProductTopEquity(props) {
  const [data, setData] = useState(false);
  const [dataExchange, setExchangeData] = useState("NSE");
  const { BaseURL, setcompserachcocode } = useContext(URLstateContext);
  const [loadingshow, setloadingshow] = useState(false);
  let navigate = useNavigate();
  const [cocode, setcocode] = useLocalStorage("cocode", "");
  const [show, setShow] = useState(false);
  const childRef = useRef(null);
  const dispatch = useDispatch();
  const usrname = useSelector(state => state.user.email);
  // console.log(usrname)
  const {  isSuccess, isError, errorMessage } = useSelector(
      userSelector
  );
  let tabName = "Stocks";


  useEffect(() => {
      if (isSuccess) {
          setShow(false);

      }
      if (isError) {
          dispatch(clearState());
      }
  }, [isSuccess, isError]);

  // const clickToggleLoginPopup = (showhide,path) => {
  //     if (isSuccess) {
  //       navigate(path);
  //     }
  //     else {
  //         childRef.current.changeTogglePopup(showhide);
  //    }
  // }


  const routeChange = (event) => {
    const compcocode = event.currentTarget.dataset.id;
    //alert("compcode:" + compcocode);
    const compcode_array = compcocode.split('-');
    const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '').replace('.','');
    var data = { "compcode": compcode_array[1], "compname": compcode_array[0] };
    setcocode(compcode_array[1]);
    const getDExchange = dataExchange;
     window.location.href = "/stocks/" + getCoCodeId.toLowerCase();
    // let path = "/stocks/" + getCoCodeId;
    // clickToggleLoginPopup(true,path)
    // alert(path)
    //navigate("/stocks/" + getCoCodeId, {
    //state: { id: `${getDExchange}`, coCode: `${getCoCodeId}` },
    //});
  };
  let actualData;
  let findExchange;

  const getUrlchart = BaseURL + "ticker/nse";
  useEffect(() => {
    setloadingshow(true);
    fetch(`${getUrlchart}`)
      .then((response) => response.json())
      .then((data) => {

        actualData = data.data;
        setloadingshow(false);
        setData(actualData);
      })
      .catch((error) => {
        // console.log("not found the api");
      });


    let widthWindow = window.matchMedia("(max-width: 450px)")
    if (widthWindow.matches) {
      setTimeout(() => {
        let sliderBtn = document.getElementsByClassName('slick-dots');
        // console.log(sliderBtn[1]);
        sliderBtn[0].firstChild.firstChild.click();
      }, 2000)
    }
  }, []);


  const getData = (exchange) => {
    //setloadingshow(true);
    const getApiUrl = BaseURL + "ticker/";
    const getMarketPara = exchange;
    findExchange = getMarketPara;
    setExchangeData(findExchange);
    fetch(`${getApiUrl}${getMarketPara}`)
      .then((response) => response.json())
      .then((data) => {
        actualData = data.data;
        //setloadingshow(false);
        setData(actualData);
      })
      .catch((error) => {
        // console.log("not found the api");
      });
    //console.log(findExchange);
  };

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 767,

        settings: {
          slidesToShow: 2,
          infinite: false,
          slidesToScroll: 2,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <section className="top-equities-block">
        <Container>
          <Row>
            <Col lg={12} md={12} sm={12}>
              <div className="top-block-header-section">
                <h3>
                  <span>Top Equities</span>
                </h3>

                <ul className="exchange-list">
                  {/* <li
                    onClick={getData}
                    className={`${dataExchange} == "NSE"` ? "active" : ""}>
                    <span>NSE</span>
                  </li>
                  <li
                    onClick={getData}
                    
                    className={`${dataExchange} == "BSE"` ? "active" : ""} >
                    <span>BSE</span>
                  </li> */}
                  <li className={dataExchange === "NSE" ? "active" : "inactive"} onClick={() => getData('NSE')} >
                    <span>NSE</span>
                  </li>
                  <li className={dataExchange === "BSE" ? "active" : "inactive"} onClick={() => getData('BSE')} >
                    <span>BSE</span>
                  </li>
                </ul>
              </div>
              {loadingshow ? <div className="textcenter">
                <Vortex
                  visible={true}
                  height="80"
                  width="80"
                  ariaLabel="vortex-loading"
                  wrapperStyle={{}}
                  wrapperClass="vortex-wrapper"
                  colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                />
                <div className="model_popup">loading data..</div>
              </div> : ""
              }
              <Slider {...settings} id="demo">

                {data &&
                  data.map(
                    ({ id, Co_Code, CompanyName, CurrPrice, PriceDiff, PerChange }) => (
                      <div key={Co_Code} className="each-equity">
                        <div className="each-equity-inner">
                          <div className="each-equity-alpha">
                            <img src={CompanyLogo} alt="CompanyLogo-img" />
                          </div>
                          <div className="each-equity-beta">
                            <div className="">
                              <h4>{CompanyName}</h4>
                            </div>
                            <h6>Share Price</h6>
                            <p>
                              &#8377; {CurrPrice}
                              <span
                                className={
                                  PriceDiff.toFixed(2) > 0
                                    ? "textGreen"
                                    : "textRed"
                                }
                              >
                                {PriceDiff.toFixed(2)}
                              </span>
                              <span
                                className={
                                  PriceDiff.toFixed(2) > 0
                                    ? "textGreen"
                                    : "textRed"
                                }
                              >
                                ({PerChange.toFixed(2)}%)
                              </span>
                            </p>
                            <h6
                              onClick={routeChange}
                              data-id={CompanyName + '-' + Co_Code}
                              id={dataExchange}
                            >
                              <ReadMore name="Know" />
                            </h6>
                          </div>
                        </div>
                      </div>

                    )
                  )}

              </Slider>
            </Col>
          </Row>
          {/* <LoginPopup show={show} ref={childRef} /> */}
        </Container>
      </section>
    </>
  );
}
export default ProductTopEquity;
